import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class MainNavItem extends Component {
	determineActive(cat) {
		if (!this.props.activeCats) return "";
		return this.props.activeCats.indexOf(cat.id) > -1 ? " open" : "";
	}

	render() {
		const cat = this.props.category;

		if (cat.hidden) return null;

		if (cat.categories) {
			return (
				<li className={"dropdown_select" + this.determineActive(cat)}>
					<div className="link_wrapper">
						<Link
							to={`/category/${cat.permalink}`}
							onClick={() => this.props.clickLink()}
						>
							{cat.title}
						</Link>
						<div
							className="drop_handle"
							onClick={() => this.props.setActiveState(cat.id)}
						/>
					</div>
					<ul className={this.determineActive(cat)}>
						{Object.keys(cat.categories).map((category, i) => {
							return (
								<MainNavItem
									key={category}
									category={cat.categories[category]}
									clickLink={this.props.clickLink}
								/>
							);
						})}
					</ul>
				</li>
			);
		}

		return (
			<li>
				<div className="link_wrapper">
					<Link to={`/category/${cat.permalink}`} onClick={() => this.props.clickLink()}>
						{cat.title}
					</Link>
				</div>
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/header/MainNavItem.js